module.exports = __webpack_public_path__ + "carousel5.da917a59.jpg";